import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import PollsPage from "./PollsPage";
import PollDetailDrawer from "../components/PollDetailDrawer";

/**
 * Anketler listesi + detay drawer.
 * /dashboard/polls/:pollId/detail URL'inde drawer açık gösterilir.
 */
const PollsWithDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { pollId } = useParams<{ pollId: string }>();

  const handleCloseDrawer = () => {
    navigate("/dashboard/polls");
  };

  return (
    <>
      <PollsPage />
      <PollDetailDrawer
        isOpen={!!pollId}
        onClose={handleCloseDrawer}
        pollId={pollId ?? null}
      />
    </>
  );
};

export default PollsWithDetailPage;
